export const navLinks = [
  { id: "entry", label: "官网入口" },
  { id: "address", label: "最新地址" },
  { id: "app", label: "App下载" },
  { id: "access", label: "多端入口" },
  { id: "guide", label: "使用指南" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { value: "12", unit: "条", label: "在测可用线路" },
  { value: "3", unit: "端", label: "安卓 / iOS / TV" },
  { value: "24", unit: "小时", label: "地址自动巡检" },
  { value: "99.9", unit: "%", label: "入口在线率" },
];

export const heroHighlights = [
  "官网、最新地址、App下载一页直达",
  "线路状态实时标注，优先推荐可用入口",
  "地址变化时无需重新搜索，收藏本页即可",
];

export const entrySteps = [
  {
    id: 1,
    icon: "ri-shield-check-line",
    title: "认准官方域名",
    desc: "先核对下方收录的官网域名清单，确认拼写与后缀无误，避开名称相近的仿冒站点，再从正规入口进入平台。",
    tag: "第一步",
  },
  {
    id: 2,
    icon: "ri-links-line",
    title: "复制最新地址",
    desc: "在「最新地址」分区挑选一条状态为在线的线路，点击复制后在浏览器地址栏打开，遇到卡顿就换下一条。",
    tag: "第二步",
  },
  {
    id: 3,
    icon: "ri-smartphone-line",
    title: "安装官方客户端",
    desc: "安卓、iOS、电视TV端任选其一，下载对应安装包完成安装，登录后即可在客户端内浏览全部内容。",
    tag: "第三步",
  },
  {
    id: 4,
    icon: "ri-bookmark-3-line",
    title: "收藏本页备用",
    desc: "把本页加入浏览器书签或收藏夹。当原地址失效时，回到这里查看最新收录的可用入口，省去反复搜索。",
    tag: "第四步",
  },
];

export const addressFilters = ["全部线路", "国内线路", "海外线路", "备用线路"];

export const addresses = [
  {
    id: 1,
    name: "线路一 · 官网主入口",
    region: "国内线路",
    tag: "推荐",
    url: "https://www.51-video-official.com",
    status: "在线",
    latency: "32ms",
    updated: "2026-10-10",
  },
  {
    id: 2,
    name: "线路二 · 电信优化",
    region: "国内线路",
    tag: "高速",
    url: "https://m3mal.com",
    status: "在线",
    latency: "38ms",
    updated: "2026-10-10",
  },
  {
    id: 3,
    name: "线路三 · 联通优化",
    region: "国内线路",
    tag: "高速",
    url: "https://m3mal.com",
    status: "在线",
    latency: "41ms",
    updated: "2026-10-10",
  },
  {
    id: 4,
    name: "线路四 · 移动优化",
    region: "国内线路",
    tag: "稳定",
    url: "https://m3mal.com",
    status: "在线",
    latency: "45ms",
    updated: "2026-10-09",
  },
  {
    id: 5,
    name: "线路五 · 网页版直达",
    region: "国内线路",
    tag: "免安装",
    url: "https://web.51-video-official.com",
    status: "在线",
    latency: "52ms",
    updated: "2026-10-09",
  },
  {
    id: 6,
    name: "海外线路一 · 通用",
    region: "海外线路",
    tag: "海外",
    url: "https://m3mal.com",
    status: "在线",
    latency: "168ms",
    updated: "2026-10-08",
  },
  {
    id: 7,
    name: "海外线路二 · 亚太",
    region: "海外线路",
    tag: "海外",
    url: "https://m3mal.com",
    status: "维护中",
    latency: "--",
    updated: "2026-10-07",
  },
  {
    id: 8,
    name: "备用线路一 · 镜像站",
    region: "备用线路",
    tag: "备用",
    url: "https://mirror1.51-video-backup.com",
    status: "在线",
    latency: "60ms",
    updated: "2026-10-06",
  },
  {
    id: 9,
    name: "备用线路二 · 镜像站",
    region: "备用线路",
    tag: "备用",
    url: "https://mirror2.51-video-backup.com",
    status: "在线",
    latency: "64ms",
    updated: "2026-10-06",
  },
  {
    id: 10,
    name: "电视TV端入口",
    region: "备用线路",
    tag: "大屏",
    url: "https://tv.51-video-official.com",
    status: "在线",
    latency: "58ms",
    updated: "2026-10-05",
  },
];

export const appClients = [
  {
    key: "android",
    label: "安卓版",
    platform: "Android 7.0 及以上",
    version: "v3.2.8",
    size: "28.6 MB",
    updated: "2026-10-10",
    file: "51shipin-android-v3.2.8.apk",
    points: [
      "支持自动更新与线路智能切换",
      "适配主流手机与平板分辨率",
      "支持后台下载与离线缓存列表",
    ],
  },
  {
    key: "ios",
    label: "iOS版",
    platform: "iOS 13.0 及以上",
    version: "v3.2.6",
    size: "41.2 MB",
    updated: "2026-10-09",
    file: "51shipin-ios-v3.2.6.ipa",
    points: [
      "通过描述文件方式安装，安装前需信任证书",
      "支持画中画与投屏到电视",
      "配合 iCloud 备份观看记录",
    ],
  },
  {
    key: "tv",
    label: "电视TV版",
    platform: "Android TV / 智能电视",
    version: "v2.8.1",
    size: "22.4 MB",
    updated: "2026-10-05",
    file: "51shipin-tv-v2.8.1.apk",
    points: [
      "专为大屏遥控操作设计",
      "支持 4K 清晰度与倍速播放",
      "适合客厅电视与电视盒子安装",
    ],
  },
];

export const accessEntries = [
  {
    icon: "ri-global-line",
    title: "网页版直达",
    desc: "无需安装，浏览器打开最新地址即可使用，适合电脑端临时访问与多设备切换。",
    method: "复制网页版地址 → 粘贴到浏览器 → 即可浏览",
  },
  {
    icon: "ri-smartphone-line",
    title: "移动 App 入口",
    desc: "安装安卓或 iOS 客户端后，桌面图标即为稳定入口，不必每次重新输入网址。",
    method: "下载对应安装包 → 完成安装 → 桌面点击图标进入",
  },
  {
    icon: "ri-tv-2-line",
    title: "电视大屏入口",
    desc: "电视TV端适合客厅大屏观看，通过U盘或电视浏览器安装后即可遥控操作。",
    method: "下载TV安装包 → U盘拷贝到电视 → 安装并打开",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "收藏本页入口",
    desc: "把本汇总页加入书签，是所有入口的总目录，地址变化时回来查看即可。",
    method: "按 Ctrl+D 或分享按钮 → 保存到收藏夹 → 随时回访",
  },
];

export const featureBlocks = [
  {
    icon: "ri-movie-2-line",
    title: "影视专区",
    desc: "院线电影、热门剧集、经典老片按类型与年份分类，支持按清晰度筛选与收藏。",
  },
  {
    icon: "ri-music-2-line",
    title: "综艺与动漫",
    desc: "每周更新的综艺节目与连载动漫集中呈现，可订阅追更提醒，更新不再错过。",
  },
  {
    icon: "ri-live-line",
    title: "直播频道",
    desc: "体育赛事、发布会等直播内容按时段排布，开播前会有入口提示，方便准时观看。",
  },
  {
    icon: "ri-history-line",
    title: "记录与续播",
    desc: "登录后自动同步观看进度与历史记录，换设备也能从上次的位置继续播放。",
  },
  {
    icon: "ri-hd-line",
    title: "清晰度切换",
    desc: "同一内容提供多档清晰度，网络不佳时可手动下调，减少缓冲与卡顿。",
  },
  {
    icon: "ri-device-line",
    title: "多端同步",
    desc: "同一账号可在手机、平板、电视间切换使用，收藏与进度保持一致。",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "打开并选择线路",
    desc: "从本页「最新地址」复制一条在线线路并在浏览器打开。如果页面加载缓慢，返回本页换用其它线路。",
  },
  {
    step: "02",
    title: "完成登录或注册",
    desc: "按平台提示登录已有账号，或按引导注册新账号。请只在当前官方页面内输入账号信息。",
  },
  {
    step: "03",
    title: "挑选想看的栏目",
    desc: "在影视、综艺、动漫、直播等分区中浏览，使用顶部搜索或类型筛选快速定位想看的内容。",
  },
  {
    step: "04",
    title: "播放与清晰度调整",
    desc: "点击内容进入播放页，播放器右下角可切换清晰度与倍速；网络波动时建议下调一档清晰度。",
  },
  {
    step: "05",
    title: "遇到打不开怎么办",
    desc: "若地址无法访问，先切换网络或更换线路；仍不可用时回到本页查看是否有更新，或改用 App 入口。",
  },
  {
    step: "06",
    title: "收藏本页保持更新",
    desc: "把本汇总页加入书签。地址轮换较频繁，收藏后可随时取回最新可用入口，无需重新搜索。",
  },
];

export const faqs = [
  {
    q: "为什么 51视频 的地址会经常变化？",
    a: "网络访问环境会随时间和地区变化，为保证访问稳定，平台会不定期启用新的访问地址。本页会把当前收录的可用线路集中列出，并标注状态与更新时间，域名更换后回到本页即可找到新入口。",
  },
  {
    q: "复制了地址却打不开，该怎么处理？",
    a: "先确认地址是否完整复制、网络是否正常。若仍无法打开，可依次尝试：更换到其它线路、切换 WiFi 与移动数据、清理浏览器缓存。如果多条线路都无法访问，说明地址可能已更新，请回到本页查看最新收录。",
  },
  {
    q: "线路里标注的延迟高低代表什么？",
    a: "延迟数值反映的是从测速节点到该线路的连接耗时，数值越小通常响应越快。它只是参考值，实际体验还会受你所在地区、运营商和当前网络环境影响，建议以自己打开页面的实际速度为准。",
  },
  {
    q: "App 客户端和网页版有什么区别？",
    a: "网页版无需安装、即开即用，适合电脑端临时访问；App 客户端在手机上更稳定、支持后台缓存和投屏，入口固定在桌面图标上。两种方式内容基本一致，按使用习惯选择即可。",
  },
  {
    q: "下载 App 时应该注意什么？",
    a: "请只从本页给出的下载入口获取安装包，不要从陌生论坛、短链接或聊天群文件安装。安卓设备安装前留意系统权限提示，iOS 安装描述文件后需要在设置中信任证书，安装完成后不建议再保留旧的来源不明的安装包。",
  },
  {
    q: "使用 51视频 需要付费吗？",
    a: "是否收费、有哪些会员权益由平台自身的规则决定，可能会调整。本页只提供官网与入口汇总，不涉及账号与付费操作。遇到以「激活」「解锁」等名义要求转账或提供验证码的情况，请提高警惕。",
  },
  {
    q: "支持哪些设备访问？",
    a: "网页版对电脑和手机浏览器均可用；客户端提供安卓版、iOS 版与电视TV版。平板一般可安装手机版使用，电视盒子与智能电视建议安装 TV 版以获得遥控器适配的大屏操作体验。",
  },
  {
    q: "怎样才能第一时间拿到最新地址？",
    a: "最省心的方式是把本页收藏到浏览器书签。地址更新时本页会同步收录，收藏后无需再次搜索即可打开。也可以记住本站名称，需要时直接访问本页。",
  },
];

export const securityTips = [
  {
    icon: "ri-alert-line",
    title: "核对域名拼写",
    desc: "仿冒站常使用相近字母或多余后缀。进入前请逐字核对域名，确认与本站收录一致再操作。",
  },
  {
    icon: "ri-download-2-line",
    title: "只装官方安装包",
    desc: "安装包仅从本页下载入口获取，不安装来源不明的文件，避免被捆绑无关软件。",
  },
  {
    icon: "ri-lock-password-line",
    title: "不在陌生页面登录",
    desc: "只在当前官方站点内输入账号密码，遇到弹窗、外链要求登录时先关闭页面确认来源。",
  },
  {
    icon: "ri-link-unlink",
    title: "谨慎点击短链接",
    desc: "聊天群与短信中的短链接无法预览真实去向，尽量通过本页地址进入，不轻信陌生分享。",
  },
  {
    icon: "ri-refresh-line",
    title: "定期回访本页",
    desc: "把本页加入书签并偶尔回访，确保你使用的始终是近期收录、状态在线的入口。",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "保护验证码与密码",
    desc: "任何以官方名义索要短信验证码、支付密码的行为都不可信，请勿向他人透露。",
  },
];

export const updateLog = [
  {
    date: "2026-10-10",
    title: "更新线路一、线路二",
    desc: "同步电信与联通优化线路，延迟与在线状态已重新测速。",
  },
  {
    date: "2026-10-09",
    title: "补充网页版直达入口",
    desc: "新增免安装网页版地址，移动端优化线路一并更新。",
  },
  {
    date: "2026-10-06",
    title: "上线两条备用镜像线路",
    desc: "当主线路临时不可用时，可切换备用镜像继续访问。",
  },
  {
    date: "2026-10-05",
    title: "新增电视 TV 端入口",
    desc: "补充大屏端下载与入口说明，适配电视遥控操作。",
  },
];

export const footerLinks = [
  { id: "entry", label: "官网入口" },
  { id: "address", label: "最新地址" },
  { id: "app", label: "App下载" },
  { id: "access", label: "多端入口" },
  { id: "guide", label: "使用指南" },
  { id: "faq", label: "常见问题" },
  { id: "security", label: "安全提示" },
  { id: "updates", label: "更新日志" },
];